<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-switch v-model="enableDefault" @change="enableDefaultHandler"></el-switch>
    <template v-if="optionModel.defaultValue != null">
      <el-input-number v-model="optionModel.defaultValue" :min="0" :max="optionModel.max" style="width: 100%" @change="emitDefaultValueChange"> </el-input-number>
    </template>
  </el-form-item>
</template>

<script>
import { reactive, computed, toRefs, onMounted } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'm-slider-defaultValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    const data = reactive({
      enableDefault: false,
    });

    const enableDefaultHandler = val => {
      if (val) props.optionModel.defaultValue = 0;
      else props.optionModel.defaultValue = null;
    };

    onMounted(() => {
      data.enableDefault = props.optionModel.defaultValue != null;
    });

    return {
      i18nt,
      ...toRefs(data),
      ...toRefs(props),
      ...properyMixins,

      enableDefaultHandler,
    };
  },
};
</script>

<style scoped></style>
